// extracted by mini-css-extract-plugin
export default {"reportViewer":"ReportViewer_reportViewer__uzJ6i"};